import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ReferrersSelect from "../../../../referrers/components/referrers-select";
import Amplitude from "../../../../../../../../shared/utils/amplitude";
import LangSelector from "@Shared/components/i18n/lang-selector.vue";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SimpleAppMethod",
  components: {
    ReferrersSelect,
    LangSelector
  },
  data() {
    return {
      selectedReferrer: null,
      customLocale: this.$root.$i18n.locale
    };
  },
  computed: {
    simpleApplicationLink() {
      var _context;
      const portalDomain = `${this.$options.filters.portalDomain("client", true)}#/application-widget/welcome`;
      const params = {};
      params.locale = this.customLocale;
      if (this.selectedReferrer) {
        params.r = this.selectedReferrer;
      }
      return _trimInstanceProperty(_context = `${portalDomain}${isEmpty(params) ? "" : `?${$.param(params)}`}`).call(_context);
    }
  },
  methods: {
    copyLink() {
      $("#link-client").select();
      document.execCommand("Copy");
      $("#copyLink").html(this.$t("application.actions.copied"));
      Amplitude.logEvent("Applications - simple application link copied from button");
    },
    handleBack() {
      this.$emit("back");
    },
    updateReferrer(referrer, type) {
      switch (type) {
        case "unselect":
          this.selectedReferrer = null;
          break;
        case "select":
          this.selectedReferrer = referrer.id;
          break;
      }
    }
  }
});